import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import api from '../api/axios';

export default function ForgotPasswordPage() {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email: data.email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen aurora stars flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8 relative z-10">
          <Link to="/" className="inline-flex items-center gap-2">
            <img src="/logo-full.png" alt="Holyweds" className="w-36 mx-auto" />
          </Link>
          <h1 className="font-heading text-3xl font-bold text-primary mt-3">Reset Password</h1>
          <p className="text-primary-500 mt-1">We'll email you a reset link</p>
        </div>

        <div className="card p-8 relative z-10">
          {sent ? (
            <div className="text-center py-4">
              <p className="text-4xl mb-3">📧</p>
              <p className="font-medium text-gray-800 mb-1">Check your email</p>
              <p className="text-sm text-gray-500">If that email is registered with Holyweds, a password reset link is on its way. It expires in 1 hour.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                <input
                  type="email"
                  placeholder="your@email.com"
                  className="input-field"
                  {...register('email', {
                    required: 'Email is required',
                    pattern: { value: /^\S+@\S+\.\S+$/, message: 'Enter a valid email' }
                  })}
                />
                {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}
              </div>
              <button type="submit" disabled={loading} className="btn-primary w-full py-3 disabled:opacity-50">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          )}

          <div className="cross-divider my-6">or</div>
          <Link to="/login" className="block text-center text-primary text-sm font-semibold hover:underline">Back to Sign In</Link>
        </div>
      </div>
    </div>
  );
}
